import isSupplementaryWorld from '../../utils/is-supplementary-world';
import { useNewWorldsModal } from './hooks/use-new-worlds-modal';
import NewWorldsModalWrapper from './new-worlds-modal-wrapper';
import './new-worlds-launch-modal.scss';

const NewWorldsLaunchModal = () => {
    const { displayNow, usersCountryCode, close, confirm } = useNewWorldsModal();

    if (!displayNow || isSupplementaryWorld()) {
        return null;
    }

    return <NewWorldsModalWrapper close={close} confirm={confirm} usersCountryCode={usersCountryCode} />;
};

export default NewWorldsLaunchModal;
